export default {
  getPreguntaTpl: state => {
    let table = 'Pregunta'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
